import { useEffect, useState } from "react";

import aliens from "../images/js-memes/aliens-js.jpeg";
import badguyCss from "../images/js-memes/badguy-css.jpg";
import blackboardCss from "../images/js-memes/blackboard-css.jpeg";
import familyGuyCss from "../images/js-memes/family-guy-css.gif";
import gatsby from "../images/js-memes/gatsby-js.jpeg";
import greekQMark from "../images/js-memes/greek-q-mark.png";
import johnnyDepp from "../images/js-memes/johnny-depp-js.jpeg";
import jsCalcs from "../images/js-memes/js-calcs-expression.jpg";
import jsInJs from "../images/js-memes/js-in-js.jpeg";
import jsJsFuturama from "../images/js-memes/javascript-javascript-futurama.jpg";
import marieKondo from "../images/js-memes/marie-kondo-js.jpg";
// import menRisks from "../images/js-memes/men-risks-js.jpg"
import millionaire from "../images/js-memes/millionaire.jpeg";
import officeSpaceJs from "../images/js-memes/office-js.jpeg";
import scary from "../images/js-memes/scary-js.jpeg";
import snl from "../images/js-memes/snl-js.jpg";
import staringComputer from "../images/js-memes/staring-computer.png";
import tapHeadGlobal from "../images/js-memes/taps-head-global-js.jpg";
import tapHeadOther from "../images/js-memes/tap-head-js.jpeg";
import tresEquis from "../images/js-memes/tres-equis.jpg";
import willyWonka from "../images/js-memes/willy-wonka.jpeg";
import zIndex from "../images/js-memes/z-index-js.jpg";

function Content() {
	const memeArray = [
        { image: aliens, altText: 'meme image' },
        { image: badguyCss, altText: 'meme image' },
        { image: blackboardCss, altText: 'meme image' },
        { image: familyGuyCss, altText: 'meme image' },
        { image: gatsby, altText: 'meme image' },
        { image: greekQMark, altText: 'meme image' },
        { image: jsJsFuturama, altText: 'meme image' },
        { image: tapHeadOther, altText: 'meme image' },
        { image: johnnyDepp, altText: 'meme image' },
        { image: jsCalcs, altText: 'meme image' },
        { image: jsInJs, altText: 'meme image' },
        { image: marieKondo, altText: 'meme image' },
        { image: millionaire, altText: 'meme image' },
        { image: officeSpaceJs, altText: 'meme image' },
        { image: scary, altText: 'meme image' },
        { image: snl, altText: 'meme image' },
        { image: staringComputer, altText: 'meme image' },
        { image: tapHeadGlobal, altText: 'meme image' },
        { image: tresEquis, altText: 'meme image' },
        { image: willyWonka, altText: 'meme image' },
        { image: zIndex, altText: 'meme image' }
    ];

	let [currentPictureIndex, setCurrentPictureIndex] = useState(0);
	let [currentPicture, setCurrentPicture] = useState(memeArray[0]);

	useEffect(() => {
		setCurrentPicture(memeArray[currentPictureIndex]);
	}, [currentPictureIndex]);

	const clickMemeAction = () => {
		console.log("CHANGING THE MEME");
		console.log(currentPictureIndex);
		if (currentPictureIndex === 20) {
			setCurrentPictureIndex(0);
		} else {
			setCurrentPictureIndex((currentPictureIndex += 1));
		}
	};

	let [showFunOpening, setShowFunOpening] = useState(true);
	let [showFunIsRelative, setShowFunIsRelative] = useState(false);
	let [showFunImages, setShowFunImages] = useState(false);

	const firstFunClicked = () => {
		setShowFunOpening(false);
		setShowFunIsRelative(true);
	};

	const secondFunClicked = () => {
		setShowFunIsRelative(false);
		setShowFunImages(true);
	};

	return (
		<div className="fun-section">
			<div className="fun-background">
				<div>
					<h2>Oh, and sometimes it will be fun..</h2>
				</div>
				{showFunOpening ? (
					<div className="click-for-fun" onClick={firstFunClicked}>
						<h4>Click for fun..</h4>
					</div>
				) : (
					<></>
				)}
				{showFunIsRelative ? (
					<div className="click-for-fun" onClick={secondFunClicked}>
						<h4>Fun is subjective and not guaranteed.. click again</h4>
					</div>
				) : (
					<></>
				)}
				{showFunImages ? (
					<div onClick={clickMemeAction} className="internal-fun-image">
						<h4>JS and CSS memes.. fun, no? (There will be other fun.) </h4>
						<img src={currentPicture.image} alt={currentPicture.altText} className="js-animation-image"></img>
					</div>
				) : (
					<></>
				)}
			</div>
		</div>
	);
}

export default Content;
